import { useSelector } from 'react-redux';

import MetaDataDisplayComponent from '../components/MetaDataDisplayComponent';
import {
  getDimensionalPrecision,
  getDisplayScale,
  getDisplayUnits,
  getMetaData,
  getNativeUnits,
} from '../data/reducer';

const MetaDataDisplay = ({ isEnabled }) => {
  const displayScale = useSelector(getDisplayScale);
  const displayUnits = useSelector(getDisplayUnits);
  const metaData = useSelector(getMetaData);
  const nativeUnits = useSelector(getNativeUnits);
  const dimensionalPrecision = useSelector(getDimensionalPrecision);

  return isEnabled ? (
    <MetaDataDisplayComponent
      displayScale={displayScale}
      displayUnits={displayUnits}
      metaData={metaData}
      nativeUnits={nativeUnits}
      dimensionalPrecision={dimensionalPrecision}
    />
  ) : null;
};

export default MetaDataDisplay;
